<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit_titmeslot.offers.title' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="isFormDirty"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  [previousUrl]="previousUrl"
  [skipSaveModal]="true"
  (submitted)="onSubmit()"
>
  <ng-container *ngIf="isBirthday">
    <app-tips
      class="block mt-6"
      [variant]="tipsVariant.WARNING"
      [title]="
        'organizer.edit_titmeslot.offers.information_box.warning.title'
          | translate
      "
      [tips]="
        'organizer.edit_titmeslot.offers.information_box.warning.description'
          | translate
      "
    >
    </app-tips>

    <app-tips
      class="block mt-3"
      [variant]="tipsVariant.INFO"
      [title]="
        'organizer.edit_titmeslot.offers.information_box.info.title' | translate
      "
      [tips]="
        'organizer.edit_titmeslot.offers.information_box.info.description'
          | translate
      "
    >
    </app-tips>
  </ng-container>

  <app-organizer-shared-form-plans
    class="block mt-6"
    [formControl]="plans"
    [editionMode]="formPlansEditionModeEnum.LIGHT"
  >
    <app-tips
      *ngIf="!isBirthday"
      class="block mt-4 -mb-4 lg:mt-6 lg:mb-0"
      [title]="'organizer.edit_titmeslot.offers.tips.title' | translate"
      [tips]="'organizer.edit_titmeslot.offers.tips.description' | translate"
    ></app-tips>
  </app-organizer-shared-form-plans>

  <app-modal-edit-timeslots
    #modalEditTimeslots
    [isLastTimeslot]="isLastTimeslot"
    (updateAllTimeslots)="updateAllTimeslotsOffers()"
    (updateTimeslot)="updateTimeslotOffers()"
    (updateSelectedTimeslots)="updateSelectedTimeslots()"
  >
  </app-modal-edit-timeslots>
</app-organizer-shared-layout-edit-field>
